import script from "./AlarmType.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlarmType.vue?vue&type=script&setup=true&lang=ts"

import "./AlarmType.vue?vue&type=style&index=0&id=63221e94&lang=scss&scoped=true"
import "./AlarmType.vue?vue&type=style&index=1&id=63221e94&lang=scss"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63221e94"]])

export default __exports__